import React from "react";
import { Label, Table } from "semantic-ui-react";
import { formatDate, getTimePart } from "@common/components/helpers/datetime";
import { HUMAN_DATE_FORMAT } from "@common/constants/datetime";

const CustomerReviewsTable = ({
  headings,
  records,
  selectedReview,
  onCustomerReviewClick,
}) => {
  return (
    <Table sortable>
      <Table.Header>
        <Table.Row>
          {headings.map((x) => (
            <Table.HeaderCell key={x.name}>
              <span>{x.label}</span>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {records?.data?.map((review, idx) => {
          const fields = [
            { value: review.id },
            { value: formatDate(review.reviewDate, HUMAN_DATE_FORMAT) },
            { value: getTimePart(review.reviewDate, HUMAN_DATE_FORMAT) },
            // { value: "-" },
            // { value: "N/A" },
          ];
          return (
            <Table.Row
              className="clickable"
              key={`${review.id}_${idx}`}
              onClick={() => onCustomerReviewClick(review.id)}
              active={review.id === selectedReview?.record?.id}
            >
              <Table.Cell>
                <Label color={review?.reviewStatus?.colour?.toLowerCase()}>
                  {review?.reviewStatus.name}
                </Label>
              </Table.Cell>
              {fields.map((field) => (
                <Table.Cell>
                  <span className={review.isClosed ? "" : "text-red"}>
                    {field.value}
                  </span>
                </Table.Cell>
              ))}
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default CustomerReviewsTable;
